import { render, staticRenderFns } from "./PintuanList.vue?vue&type=template&id=1cf971fa&scoped=true&"
import script from "./PintuanList.vue?vue&type=script&lang=js&"
export * from "./PintuanList.vue?vue&type=script&lang=js&"
import style0 from "./PintuanList.vue?vue&type=style&index=0&id=1cf971fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf971fa",
  null
  
)

export default component.exports